import Main from "../../pages/Main.vue";
import PageName from "../../constant/PageName";
import PermissionIds from "../../constant/PermissionIds";
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: "/system",
    icon: "md-list",
    name: "system",
    title: "系统管理",
    component: Main,
    children: [
      {
        path: "user",
        title: "用户管理",
        name: PageName.PAGE_USER_INDEX,
        permissionId: PermissionIds.PERMISSION_USER_INDEX,
        component: function(resolve) {
          require(["../../pages/system/user/user.vue"], resolve);
        }
      },
      {
        path: "role",
        title: "角色管理",
        name: PageName.PAGE_ROLE_INDEX,
        permissionId: PermissionIds.PERMISSION_ROLE_INDEX,
        component: function(resolve) {
          require(["../../pages/system/role.vue"], resolve);
        }
      },
      {
        path: "permission",
        title: "权限管理",
        name: PageName.PAGE_PERMISSION_INDEX,
        permissionId: PermissionIds.PERMISSION_PERMISSION_INDEX,
        component: function(resolve) {
          require(["../../pages/system/permission.vue"], resolve);
        }
      },
      /** 授权码管理部分 **/
      {
        path: "channelAuthCode",
        title: "授权码管理",
        name: PageName.PAGE_SYSTEM_CHANNELAUTHCODE,
        permissionId: PermissionIds.PERMISSION_SYSTEM_CHANNELAUTHCODE,
        component: function(resolve) {
          require([
            "../../pages/system/channelAuthCode/ChannelAuthCode.vue"
          ], resolve);
        }
      },
      /** 机构管理部分 **/
      {
        path: "organ",
        title: "机构信息",
        name: PageName.PAGE_SYSTEM_ORGAN,
        permissionId: PermissionIds.PERMISSION_SYSTEM_ORGAN,
        component: function(resolve) {
          require(["../../pages/system/organ/Organ.vue"], resolve);
        }
      },
      /** 商户管理部分 **/
      {
        path: "merchants",
        title: "商户管理",
        name: PageName.PAGE_SYSTEM_MERCHANTS,
        permissionId: PermissionIds.PERMISSION_SYSTEM_MERCHANTS,
        component: function(resolve) {
          require(["../../pages/system/merchants/Merchants.vue"], resolve);
        }
      },
      /** 系统配置 **/
      {
        path: "bsSysConfig",
        title: "系统配置",
        name: PageName.PAGE_SYSTEM_BSSYSCONFIG,
        permissionId: PermissionIds.PERMISSION_SYSTEM_BSSYSCONFIG,
        component: function(resolve) {
          require(["../../pages/system/bsSysConfig/bsSysConfig.vue"], resolve);
        }
      }
    ]
  }
];

export const baseRouter = [
  {
    path: "/locking",
    name: PageName.PAGE_LOCKING,
    component: function(resolve) {
      require([
        "../../components/main-components/lockscreen/components/locking-page.vue"
      ], resolve);
    }
  },
  {
    path: "/login",
    name: PageName.PAGE_LOGIN,
    meta: {
      title: "Login - 登录"
    },
    component: function(resolve) {
      require(["../../pages/login/login.vue"], resolve);
    }
  },
  {
    path: "/RedHeiBang",
    title: "红黑榜详情",
    name: PageName.PAGE_BUSINESS_REDHEIBANG,
    component: function(resolve) {
      require(["../../pages/business/Inspector/redHeiBang.vue"], resolve);
    }
  },
  {
    path: "/*",
    name: "error-404",
    meta: {
      title: "404-页面不存在"
    },
    component: function(resolve) {
      require(["../../pages/error-page/404.vue"], resolve);
    }
  },
  {
    path: "/403",
    meta: {
      title: "403-权限不足"
    },
    name: "error-403",
    component: function(resolve) {
      require(["../../pages/error-page/403.vue"], resolve);
    }
  },
  {
    path: "/500",
    meta: {
      title: "500-服务端错误"
    },
    name: "error-500",
    component: function(resolve) {
      require(["../../pages/error-page/500.vue"], resolve);
    }
  }
];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: "/",
  name: "otherRouter",
  title: "首页",
  redirect: "/home",
  component: Main,
  children: [
    {
      path: "home",
      title: "首页",
      name: PageName.PAGE_HOME_INDEX,
      component: function(resolve) {
        require(["../../pages/Home.vue"], resolve);
      }
    },
    {
      path: "/user/add",
      title: "新增用户",
      name: PageName.PAGE_USER_ADD,
      component: function(resolve) {
        require(["../../pages/system/user/user_add.vue"], resolve);
      }
    },
    {
      path: "/user/update",
      title: "修改用户",
      name: PageName.PAGE_USER_UPDATE,
      component: function(resolve) {
        require(["../../pages/system/user/user_update.vue"], resolve);
      }
    },
    {
      path: "/dictType/dictData",
      title: "字典数据",
      name: PageName.PAGE_DICTDATA,
      component: function(resolve) {
        require(["../../pages/system/dictType/dictData/dictData.vue"], resolve);
      }
    },

    {
      path: "/system/banner/add",
      title: "新增轮播图",
      name: PageName.PAGE_SYSTEM_BANNER_ADD,
      component: function(resolve) {
        require(["../../pages/system/banner/banner_add.vue"], resolve);
      }
    },
    {
      path: "/system/banner/update",
      title: "修改轮播图",
      name: PageName.PAGE_SYSTEM_BANNER_UPDATE,
      component: function(resolve) {
        require(["../../pages/system/banner/banner_update.vue"], resolve);
      }
    },
    {
      path: "/system/appVersion/rnVersion",
      title: "RN版本管理",
      name: PageName.PAGE_RN_INDEX,
      component: function(resolve) {
        require(["../../pages/system/appVersion/rnVersion.vue"], resolve);
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routers/D_systemRouter.js